module.exports = __webpack_public_path__ + "static/img/pms.c96c68d.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/pms.png
// module id = 6G0s
// module chunks = 1